<template>
  <div>
    <div class="box">
      <el-input
        class="search"
        placeholder="请输入检索内容"
        prefix-icon="el-icon-search"
        autofocus="true"
        v-model="inputValue"
        type="search"
        @click.native="exit"
        @input="searchAction"
        @keypress.native="searchEnter"
      >
      </el-input>
      <div class="text" @click="back">取消</div>
    </div>
    <!-- 条件判断显示为空还是显示提示栏 -->
    <div>
      <!-- inputValue长度为0的时候隐藏 -->
      <div v-if="inputValue.length != 0" style="margin-top:3.5rem">
        <el-card class="box-card" v-show="isShow" shadow="never">
            <div
            prefix-icon="el-icon-search"
            v-for="(list, i) in searchResult.product"
            :key="i"
          >
          <div @click="change1(list.name)" class="box_line">
              <img class="img1" src="../assets/img/search1.png" />
              {{ list.name }}
          </div>
          </div>
          <div>
          <div
            prefix-icon="el-icon-search"
            v-for="(item, index) in searchResult.news"
            :key="index"
          >
          <div @click="change1(item.title)" class="box_line">
              <img class="img1" src="../assets/img/search1.png" />
              {{ item.title }}
          </div>
          </div>
          </div>

        </el-card>
      </div>

      <div v-else>
        <el-empty description="——暂无检索信息——"></el-empty>
      </div>
    </div>
    <el-tabs v-model="activeName"  v-show="!isShow">
      <el-tab-pane label="产品" name="first">
        <div v-for="(list,i) in searchResult.product"  class="list5">
        <!-- <div v-show="list.product.title != ''"> -->
            <!-- 列的第一个 -->
        <el-card class="box5" v-show="list.name != ''">
            <img class="img5" v-if="list.cover != undefined" :src="list.cover"></img>
            <div class="text5">
                {{list.name}}
            </div>
            <div class="link">
            <!-- <router-link to="/services/servicesList/category/detail" class="link1">
                查看详情
            </router-link> -->
            <div class="link1" @click="toServicesDetail(list.id)">
                查看详情
            </div>
            </div>
        </el-card>
        <!-- 列的第二个 -->
        <div class="box6" v-if='i+1<searchResult.product.length' v-show="list.name != ''">
            <el-card>
                <img class="img5" v-if="searchResult.product[i+1].cover != undefined"  :src="searchResult.product[i+1].cover"></img>
            <div class="text5">
                {{searchResult.product[i].name}}
            </div>
            <div class="link">
            <!-- <router-link to="/services/servicesList/category/detail" class="link1" >
                查看详情
            </router-link> -->
            <div class="link1" @click="toServicesDetail(list.id)">
                查看详情
            </div>
            </div>
            </el-card>
        </div>
        <!-- </div> -->
        
        </div>
            <div style="margin-bottom:2rem">
                <img v-if="this.count2" class="more" src="../assets/img/more.png" />
                <el-empty  v-else description="——暂无检索信息——"></el-empty>
            </div>
      </el-tab-pane>
      <el-tab-pane label="新闻" name="second">
        <div v-for="(item, p) in searchResult.news" :key="p">
          <div v-show="item.title != ''">
            <div class="newsCard" @click="toLinkDetail(item.id)">
            <el-image
              style="width: 12.25rem; height: 11.25rem; float: left"
              v-if="item.cover != undefined" 
              :src="item.cover"
              fit="fill"
            ></el-image>
            <div class="newsIn">
              <div class="newsTitle">{{ item.title }}</div>
              <div class="newsContext">{{ item.desc }}</div>
            </div>
          </div>
          </div>
        </div>
            <div style="margin-bottom:2rem">
            <img v-if="this.count1" class="more" src="../assets/img/more.png" />
            <el-empty  v-else description="——暂无检索信息——"></el-empty>
            </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
// import Headfirst from '../views/Index/Index_components/Headfirst.vue'
import Search from '../views/Index/Index_components/Search.vue'
import api from '@/utils/api'
export default {
  name: 'SearchPage',
  data () {
    return {
      inputValue: '',
      searchResult: [],
      isShow: true,
      activeName: 'first',
      count1: false,
      count2: false
    }
  },
  components: {
    Search,
  },
  methods: {
      showme(e) {
          console.log('图片',e)
      },
    toLinkDetail (index) {
      this.$router.push({
        path: '/news/detail',
        query: {
          type: '1',
          id: index,
        },
      })
    },
    toServicesDetail (index) {
      this.$router.push({
        path: '/services/servicesList/category/detail',
        query: {
          id: index,
        },
      })
    },

    //   点击对应的卡片改变绑定的值
    change1 (e) {
      console.log('我被点击了')
      console.log('e', e)
      this.inputValue = e
      this.isShow = !this.isShow
      this.searchAction()
    },
    changeOrSearch () {
      // setTimeout(this.change(item),5000)
      // this.change(item)
      this.inputValue = this.inputValue
      this.isShow = !this.isShow
      this.searchAction()
    },
    searchEnter () {
        console.log('我是entry触发')
      this.inputValue = this.inputValue
      this.isShow = !this.isShow
      this.searchAction()
    },
    //   获取e，通过target.value获取值,可以设置节流
    async searchAction (event) {
      const { data:data } = await api.getSearch(this.inputValue)
      console.log(`我是${this.inputValue}搜索结果`, data)
      //   给空数组searchResult赋值
      //   this.searchResult = this.courseData.filter((item) => {
      //     if (
      //       item.product.title.includes(inputValue) ||
      //       item.news.title.includes(inputValue)
      //     ) {
      //       return item
      //     }
      //   })
      this.searchResult = data.data
      if (this.searchResult.news.length === 0) {
        this.count1 = false
      } else {
        this.count1 = true
      }
      if (this.searchResult.product.length === 0) {
        this.count2 = false
      } else {
        this.count2 = true
      }
    },
    exit () {
      this.searchResult = []
      this.isShow = true
      this.count1 = false
      this.count2 = false
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>
<style scoped>
.link1 {
  font-size: 1.5rem;
  color: #0099da;
  text-decoration: none;
}

/deep/ .link {
  padding-top: 1.125rem !important;
  text-align: center;
}
.more {
  margin-top: 4rem;
  margin-left: 15.75rem;
  width: 15.375rem;
  height: 2.1875rem;
}
/* 滑块样式 */
/deep/.el-tabs__active-bar {
  height: 0.25rem;
  background-color: #0099da;
}
/deep/ .el-tabs__nav-scroll {
  margin-left: 2.1875rem;
}
/deep/ .el-tabs__item {
  min-width: 3.5rem;
  height: 5.5rem;
  padding-top: 1.5rem;
  font-size: 1.75rem;
  color: #666666;
}
/* 选中的样式 */
/deep/ .el-tabs__item.is-active {
  font-weight: bold;
  color: #333333;
  font-size: 1.75rem;
}
/deep/ .box_line {
  width: 43.875rem !important;
  height: 2.5rem !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #333333;
  font-size: 1.75rem;
  line-height: 2.5rem;
  margin-bottom: 3rem;
}
/deep/ .el-card__body {
  padding: 0rem;
  height: 22rem;
}

/* 产品模块 */
.text5 {
  max-width: 21.25rem;
  margin-top: 2.125rem;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.img5 {
  margin-top: 2.3125rem;
  margin-left: 5.8125rem;
  width: 9.6875rem;
  height: 10.6875rem;
}
.list5 {
  display: flex;
  justify-content: space-between;
}
.box5 {
  width: 21.25rem;
  height: 22rem;
  margin-left: 1.5rem;
  /* margin-bottom: 2rem; */
}
.box6 {
  width: 21.25rem;
  height: 22rem;
  margin-right: 1.5rem;
  margin-bottom: 2rem;
}
/* 文字 */
.text1 {
  margin-left: 1rem;
}
/* 新闻模块 */
.newsCard {
  width: 43.875rem;
  height: 11.25rem;
  margin: 1rem 1.5rem;
}
.newsIn {
  float: left;
  width: 31.625rem;
  height: 11.25rem;
  background-color: #f5f5f5;
}
.newsTitle {
  font-size: 1.5rem;
  color: #333333;
  margin-left: 1rem;
  margin-top: 1rem;
}
.newsContext {
  font-size: 1.75rem;
  color: #333333;
  margin-left: 1rem;
}
.search {
  padding-left: 24px;
  width: 643px;
}
/deep/ .el-empty__description p {
  font-size: 28px;
}
.box {
  display: flex;
  margin-top: 1rem;
}
.text {
  text-align: center;
  width: 70px;
  height: 40px;
  font-size: 28px;
  padding-top: 16px;
  color: #999999;
}
/deep/ .el-icon-search {
  padding-top: 17px;
  font-size: 30.62px;
  padding-left: 31.81px;
}
/deep/ .el-input--prefix .el-input__inner {
  font-size: 25px;
  height: 72px;
  width: 621px;
}
/deep/ .el-input__inner {
  padding-left: 72.19px !important;
  /* //css3中的仅修改闪烁光标的样式 */
  caret-color: #0099da;
  border-width: 3px;
}
/deep/ .img1 {
  width: 2rem !important;
  height: 2rem !important;
  padding-left: 1.5rem !important;
  padding-right: 1rem;
  margin: auto;
}
/* card边框 */
/deep/ .el-card__body {
  padding: 0rem !important;
  height: 22rem;
}
</style>
